import { useState } from 'react';

import { useGetElementById } from './useGetElementById';
import { useResizeObserver } from './useResizeObserver';

/**
 * Get the width of a container element by its DOM id.
 * @param containerId The id of the container element
 * @returns width: The current width of the container
 */

type ResultType = {
  width: number;
};

export const useContainerWidth = (containerId: string): ResultType => {
  const container = useGetElementById(containerId);
  const [width, setWidth] = useState(0);

  useResizeObserver({
    target: container,
    onResize: (entry) => {
      setWidth(entry.clientWidth);
    },
  });

  return { width };
};
